import * as React from "react";
import { useCallback, useState } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import { Col, ControlLabel, FormGroup, Input, Radio, Row } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
import FilterForm from "./FilterForm";
import FilterPreviewContainer from "./FilterPreviewContainer";
import AggregationForm from "./AggregationForm";
const conditionTypes = {
  AGGREGATION: 0,
  FILTER: 1
};
const initialFilterConfig = {
  query: "",
  query_parameters: [],
  streams: [],
  stream_categories: [],
  filters: [],
  search_within_ms: 5 * 60 * 1e3,
  execute_every_ms: 5 * 60 * 1e3,
  _is_scheduled: true,
  event_limit: 100,
  use_cron_scheduling: false
};
const initialAggregationConfig = {
  group_by: [],
  series: [],
  conditions: {}
};
const FilterAggregationForm = ({ entityTypes, eventDefinition, streams, validation, currentUser, onChange }) => {
  var _a;
  const { group_by, series, conditions } = eventDefinition.config;
  const expression = (_a = conditions == null ? void 0 : conditions.expression) != null ? _a : {};
  const [conditionType, setConditionType] = useState(
    isEmpty(group_by) && isEmpty(series) && isEmpty(expression) ? conditionTypes.FILTER : conditionTypes.AGGREGATION
  );
  const [existingAggregationConfig, setExistingAggregationConfig] = useState();
  const propagateConfigChange = useCallback(
    (config) => {
      onChange("config", config);
    },
    [onChange]
  );
  const handleConfigChange = useCallback(
    (event) => {
      const config = cloneDeep(eventDefinition.config);
      config[event.target.name] = FormsUtils.getValueFromInput(event.target);
      propagateConfigChange(config);
    },
    [propagateConfigChange, eventDefinition.config]
  );
  const handleTypeChange = useCallback(
    (event) => {
      const nextConditionType = Number(FormsUtils.getValueFromInput(event.target));
      setConditionType(nextConditionType);
      let newExistingAggregationConfig;
      if (nextConditionType === conditionTypes.FILTER) {
        Object.keys(initialAggregationConfig).forEach((key) => {
          newExistingAggregationConfig[key] = eventDefinition.config[key];
        });
        const nextConfig = { ...eventDefinition.config, ...initialAggregationConfig };
        propagateConfigChange(nextConfig);
      } else if (existingAggregationConfig) {
        const nextConfig = { ...eventDefinition.config, ...existingAggregationConfig };
        propagateConfigChange(nextConfig);
        newExistingAggregationConfig = void 0;
      }
      setExistingAggregationConfig(newExistingAggregationConfig);
    },
    [eventDefinition.config, existingAggregationConfig, propagateConfigChange]
  );
  const onlyFilters = eventDefinition._scope === "ILLUMINATE";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 7, lg: 6 }, /* @__PURE__ */ React.createElement(
    FilterForm,
    {
      eventDefinition,
      validation,
      streams: streams.filter((s) => s.is_editable),
      currentUser,
      onChange
    }
  ), onlyFilters || /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "Create Events for Definition if..."), /* @__PURE__ */ React.createElement(
    Radio,
    {
      id: "filter-type",
      name: "conditionType",
      value: conditionTypes.FILTER,
      checked: conditionType === conditionTypes.FILTER,
      onChange: handleTypeChange
    },
    "Filter has results"
  ), /* @__PURE__ */ React.createElement(
    Radio,
    {
      id: "aggregation-type",
      name: "conditionType",
      value: conditionTypes.AGGREGATION,
      checked: conditionType === conditionTypes.AGGREGATION,
      onChange: handleTypeChange
    },
    "Aggregation of results reaches a threshold"
  )), conditionType === conditionTypes.FILTER && !onlyFilters && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "event-limit",
      name: "event_limit",
      label: "Event Limit",
      type: "number",
      bsStyle: validation.errors.event_limit ? "error" : null,
      help: get(
        validation,
        "errors.event_limit",
        "Maximum number of events to be created per execution of this event definition. Excess events will be suppressed."
      ),
      value: eventDefinition.config.event_limit,
      onChange: handleConfigChange,
      required: true
    }
  )))), /* @__PURE__ */ React.createElement(Col, { md: 5, lgOffset: 1 }, /* @__PURE__ */ React.createElement(FilterPreviewContainer, { eventDefinition }))), conditionType === conditionTypes.AGGREGATION && !onlyFilters && /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    AggregationForm,
    {
      eventDefinition,
      validation,
      aggregationFunctions: entityTypes.aggregation_functions,
      onChange
    }
  ))));
};
FilterAggregationForm.defaultConfig = {
  ...initialFilterConfig,
  ...initialAggregationConfig
};
export default FilterAggregationForm;
